import { PurchasingRepository } from '@Purchasing/Data/Repository/PurchasingRepository'
import { CreatePurchaseProcessPayload } from '@Purchasing/Data/DataSource/API/Entity/PurchaseProcess'
import { PurchaseProcess } from '@Purchasing/Domain/Model/PurchaseProcess'

export interface CreatePurchaseProcess {
    execute(payload: CreatePurchaseProcessPayload): Promise<PurchaseProcess>
    getSource(): string
}

export class CreatePurchaseProcessUseCase implements CreatePurchaseProcess {
    constructor(private repository: PurchasingRepository) {}
    async execute(
        payload: CreatePurchaseProcessPayload
    ): Promise<PurchaseProcess> {
        return this.repository.create(payload)
    }
    getSource(): string {
        return this.repository.dataSource.getSource()
    }
}
